import ListingItem from "../LisingItem";

// markup
import CreditAppLoanDetails from "./LoanDetails";
import ApplicationDetailsInternal from "./CreditApplicationDetailsCmps/ApplicationDetailsInternal";

const PersonalCreditApplicationDetails = (props) => {
  let application = props.application;
  let accountInfo = props.accountInfos[application.BorrowerId];
  let lineStyle = { float: "left", whiteSpace: "normal", marginLeft: "20px" };

  const extraContentStyle = {
    position: "relative",
    display: "flex",
    flexDirection: "column",
  };

  return (
    <div style={extraContentStyle}>
      {application.LoanId != null && (
        <div style={lineStyle}>
          <ListingItem primaryText={"Loan"} />
          {props.loan ? (
            <CreditAppLoanDetails loan={props.loan} />
          ) : (
            <ListingItem
              secondaryText={
                "Loan details could not be fetched, likely due to the loan not being paid out yet."
              }
            />
          )}
        </div>
      )}
      <ApplicationDetailsInternal
        application={application}
        accountInfo={accountInfo}
        rejectCreditApplication={props.rejectCreditApplication}
        approveRejectCreditOffers={props.approveRejectCreditOffers}
        approveCreditOffer={props.approveCreditOffer}
        rejectCreditOffer={props.rejectCreditOffer}
      />
    </div>
  );
};

export default PersonalCreditApplicationDetails;
